(function (angular) {

  angular.module("alk.uirouter", []);

})(window.angular);



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-uirouter/module.js